import 'hammerjs';
/** 
 *   _______  ___    ___  ______
 *   \_    _\ \  \  /  / /_   _/
 *     |  |    \  \/  /   |  |      TYT 2.0
 *     |  |     \    /    |  |      © 2017 TYT NETWORK
 *     |  |      |  |     |  |
 *      \_|      |  |     |_/
 *                \/
 *
 */

if (typeof console === 'undefined')
  (window as any)['console'] = { log: function() { } };

import "reflect-metadata";
import "polyfill-array-includes";

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { Logger } from './common';
import { environment } from '@tytapp/environment';
import Bugsnag from '@bugsnag/js';

// import { APMServiceBrowser } from "./common/apm.client";
// import { APMService } from "./common/apm";

if (environment.production)
  enableProdMode();
  
Bugsnag.start({
  apiKey: '100b690374ca57ef9bc9b16b1dd9c08a',
  releaseStage: environment.name
});

document.addEventListener('DOMContentLoaded', () => {
  // Remove once this PR lands https://github.com/angular/preboot/issues/91
  setTimeout(() => {
    platformBrowserDynamic().bootstrapModule(AppModule, { 
      //providers: [ { provide: APMService, useClass: APMServiceBrowser, deps: [] } ] 
    }).then(async () => {

      // We shouldn't have to do this ourselves, but for some reason it doesn't register itself
      // in almost all circumstances
      
      if ('serviceWorker' in navigator && environment.enableServiceWorker) {
        try {
          await navigator.serviceWorker.register('ngsw-worker.js');
        } catch (e) {
          console.error(`Failed to register service worker [it will be skipped]: ${e.message}`);
          console.error(e);
        }
      }
      
    });
  }, 10);
});